// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tktE","col":"styles_col__1ZVSC"};